import { render } from "./SidebarSection.vue?vue&type=template&id=0da4eeed"
import script from "./SidebarSection.vue?vue&type=script&lang=js"
export * from "./SidebarSection.vue?vue&type=script&lang=js"

import "./SidebarSection.vue?vue&type=style&index=0&id=0da4eeed&lang=css"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__